import { Box, Container, Typography, Button } from "@mui/material";

import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CallIcon from "@mui/icons-material/Call";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import BoltIcon from "@mui/icons-material/Bolt";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";

import ctaBg from "../../assets/images/cta_bg.png";
import ctaBgm from "../../assets/images/cta_bg_m.png";

export default function CTASection() {
  return (
    <Box
      sx={{
        py: {
          xs: 4,
          md: 6,
        },

        backgroundImage: {
          xs: `url(${ctaBgm})`,
          md: `url(${ctaBg})`,
        },

        backgroundSize: "cover",

        backgroundPosition: "center",

        backgroundRepeat: "no-repeat",

        position: "relative",
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            position: "relative",

            overflow: "hidden",

            borderRadius: {
              xs: "30px",
              md: "42px",
            },

            p: {
              xs: 4,
              sm: 5,
              md: 8,
            },

            backgroundImage: { xs: `url(${ctaBgm})`, md: `url(${ctaBg})` },

            backgroundSize: "cover",

            backgroundPosition: "center",

            backgroundRepeat: "no-repeat",

            border: "1px solid rgba(255,255,255,.85)",

            boxShadow: "0 30px 80px rgba(0,87,255,.12)",

            textAlign: "center",
          }}
        >
          {/* BADGE */}
          <Box
            sx={{
              display: "flex",

              justifyContent: "center",

              mb: 2,
            }}
          >
            <Box
              sx={{
                px: {
                  xs: 2,
                  md: 2.5,
                },

                py: 1,

                borderRadius: "50px",

                background: "rgba(255,255,255,.65)",

                backdropFilter: "blur(12px)",

                border: "1px solid rgba(0,87,255,.08)",

                color: "#0057ff",

                fontWeight: 700,

                textTransform: "uppercase",

                letterSpacing: "1px",

                fontSize: {
                  xs: "11px",
                  md: "12px",
                },
                width: "fit-content",
              }}
            >
              Premium Care Services
            </Box>
          </Box>
          {/* HEADING */}

          <Typography
            sx={{
              mt: 2,

              fontWeight: 900,

              lineHeight: 1.05,

              color: "#07122F",

              fontSize: {
                xs: "28px",
                sm: "30px",
                md: "72px",
              },
            }}
          >
            Ready To Experience
            <br />
            <Box
              component="span"
              sx={{
                background: "linear-gradient(135deg,#0057FF,#4AA3FF)",

                WebkitBackgroundClip: "text",

                WebkitTextFillColor: "transparent",
              }}
            >
              Premium Care Under One Roof?
            </Box>
          </Typography>

          {/* DESCRIPTION */}

          <Typography
            sx={{
              mt: 2,

              //   maxWidth: "900px",

              mx: "auto",

              color: "#64748B",

              lineHeight: 1.8,

              fontSize: {
                xs: "12px",
                md: "19px",
              },
            }}
          >
            Discover professional cleaning, repairs, custom printing and
            specialty care services delivered with exceptional quality, expert
            attention and convenience trusted by families across Ajax.
          </Typography>

          {/* FEATURES */}

          <Box
            sx={{
              mt: 4,

              display: "flex",

              flexWrap: "wrap",

              justifyContent: "center",

              gap: 1.2,
            }}
          >
            {[
              {
                icon: <LocalShippingIcon />,
                text: "Free Pickup",
              },
              {
                icon: <BoltIcon />,
                text: "Same Day Service",
              },
              {
                icon: <WorkspacePremiumIcon />,
                text: "Premium Care",
              },
            ].map((item, i) => (
              <Box
                key={i}
                sx={{
                  display: "flex",

                  alignItems: "center",

                  gap: 1,

                  px: 2,

                  py: 1,

                  borderRadius: "50px",

                  background: "rgba(255,255,255,.75)",

                  backdropFilter: "blur(12px)",

                  border: "1px solid rgba(255,255,255,.8)",

                  fontSize: "13px",

                  fontWeight: 700,

                  color: "#12305F",
                }}
              >
                <Box
                  sx={{
                    display: "flex",

                    color: "#0057FF",
                  }}
                >
                  {item.icon}
                </Box>

                {item.text}
              </Box>
            ))}
          </Box>

          {/* BUTTONS */}

          <Box
            sx={{
              mt: 5,

              display: "flex",

              flexWrap: "wrap",

              justifyContent: "center",

              gap: 2,
            }}
          >
            <Button
              startIcon={<WhatsAppIcon />}
              href="https://wa.me/+19054283542"
              target="_blank"
              component="a"
              sx={{
                px: 4,

                py: 1.7,

                borderRadius: "60px",

                color: "#fff",

                fontWeight: 800,

                fontSize: "15px",

                background: "linear-gradient(135deg,#25D366,#18B957)",

                boxShadow: "0 15px 35px rgba(37,211,102,.25)",
              }}
            >
              WhatsApp Us
            </Button>

            <Button
              startIcon={<CallIcon />}
              href="tel:+19054283542"
              target="_blank"
              component="a"
              sx={{
                px: 4,

                py: 1.7,

                borderRadius: "60px",

                fontWeight: 800,

                fontSize: "15px",

                color: "#0057FF",

                background: "rgba(255,255,255,.8)",

                border: "1px solid rgba(255,255,255,.9)",

                backdropFilter: "blur(15px)",
              }}
            >
              Call Now
            </Button>
          </Box>

          {/* STATS */}

          <Box
            sx={{
              mt: 6,

              display: "flex",

              flexWrap: "wrap",

              justifyContent: "center",

              gap: {
                xs: 3,
                md: 8,
              },
            }}
          >
            {[
              {
                number: "1000+",
                label: "Happy Customers",
              },
              {
                number: "10+",
                label: "Years Experience",
              },
              {
                number: "99%",
                label: "Customer Satisfaction",
              },
            ].map((item, index) => (
              <Box key={index}>
                <Typography
                  sx={{
                    fontWeight: 900,

                    color: "#0057FF",

                    fontSize: {
                      xs: "34px",
                      md: "48px",
                    },
                  }}
                >
                  {item.number}
                </Typography>

                <Typography
                  sx={{
                    color: "#64748B",

                    fontSize: "14px",
                  }}
                >
                  {item.label}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
